module.exports = __webpack_public_path__ + "media/images/emblems/Hindelbank-coat_of_arms-3b97d130790cb6742adfce7518a00bbe.svg";